import { Injectable } from '@angular/core';
import { GlobalHeaderConfig } from '@vi/global-header';
import { environment } from '../../environments/environment';
import { replaceDomainUrl } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class RuntimeConfigService {
    constructor() {}

    ghConfig: GlobalHeaderConfig;

    init(): void {
        this.ghConfig = {
            appId: environment.auth.appId,
            baseUrl: replaceDomainUrl(environment.auth.baseUrl),
            accountAppUrl: environment.auth.registerBaseUrl,
        };
    }

    getGlobalHeaderConfig(): GlobalHeaderConfig {
        return this.ghConfig;
    }
}
